<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref, onMounted } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiHomeSearch, mdiWhatsapp, mdiCashPlus,
    mdiCradle, mdiPuzzleRemove, mdiTownHall, mdiCross, mdiPill, mdiMedicalBag, mdiGymnastics, mdiWater, mdiCheckDecagram, mdiContentSave, mdiAccountSupervisor,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail, mdiInformationOutline, mdiPrinter, mdiFileDocumentMultipleOutline,
    mdiCardAccountDetails, mdiGenderMaleFemale, mdiCellphone, mdiEmail, mdiClockTimeFive
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import { Inertia } from '@inertiajs/inertia';
// Breeze
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';


import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    tallas: Object,
    user_modif: Object,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    back_link: String,
    debugInertia: Boolean,

});


/* LRR
{
start: '2018-11-19 12:00', // Required.
end: '2018-11-19 14:00', // Required.
// Instead of formatted dates, you can also provide Javascript Date objects:
// start: new Date(2018, 11 - 1, 19, 12, 0),
// end: new Date(2018, 11 - 1, 19, 14, 0),
title: {String}, // Optional.
content: {String}, // Optional.
class: {String}, // Optional - space-separated css classes.
background: {Boolean} // Optional. (Event type not CSS property)
split: {Number|String} // Optional.
allDay: {Boolean} // Optional.
deletable: false // optional - force undeletable when events are editable.
resizable: false // optional - force unresizable when events are editable.
}
*/
const anioSearch = ref(null)

/* onMounted(() => {
    
}); */

//console.log(props.typeDocuments)
// Carga de objeto
const rutaPrefijo = ref('product')
const modulo = ref('product')
const modulos = ref('Productos')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Producto
    ref: props.object ? props.object.ref : null,
    label: props.object ? props.object.label : null,
    description: props.object ? props.object.description : null,
    price: props.object ? props.object.price : 0,
    price_ttc: props.object ? props.object.price_ttc : 0,
    //price_base_type: props.object ? props.object.price_base_type : '',
    tva_tx: props.object ? props.object.tva_tx : '0.00',
    cost_price: props.object ? props.object.cost_price : 0,
    tosell: props.object ? props.object.tosell : 1,
    tobuy: props.object ? props.object.tobuy : 1,
    id_talla: props.object ? props.object.id_talla : 0,
    stock: props.object ? props.object.stock : 0,
    stock_alerta: props.object ? props.object.stock_alerta : 0

});


// id => value y label => label
//const typeIGV = ref([{'id': 0, 'label': '0'}, {'id': 18, 'label': '18'}])

const clean = (origen = '') => {

    if (origen == 'product') {
        action.value = 'view'
    }

}

/**
 * 
 * LRR 
 * Incializar valorres
 */

const optionsIgvTasa = [
    { id: '0.00', label: '0' },
    { id: '18.00', label: '18' },
]
const optionsPriceBase = [
    { id: 'HT', label: 'HT' },
    { id: 'HT', label: 'TTC' },
]

const optionsIgvCode = [
    { id: 'GRAV', label: 'GRAV' },
    { id: 'EXO', label: 'EXO' },
    { id: 'INA', label: 'INA' },
]
/*
const optionsVivienda = [
    {id: 0, label: 'Casa propia'},
    {id: 1, label: 'Casa alquilada'},
    {id: 2, label: 'Casa de otros familiares'},
    {id: 3, label: 'Casa alquilada'},
    {id: 9, label: 'Otro :'},
]
*/

// Usar objecto de 
/*const json = '{"result":true, "count":42}';
const obj = JSON.parse(json);
Y
console.log(JSON.stringify({ x: 5, y: 6 }));
// expected output: "{"x":5,"y":6}"

console.log(JSON.stringify([new Number(3), new String('false'), new Boolean(false)]));
// expected output: "[3,"false",false]"

console.log(JSON.stringify({ x: [10, undefined, function(){}, Symbol('')] }));
// expected output: "{"x":[10,null,null,null]}"

console.log(JSON.stringify(new Date(2006, 0, 2, 15, 4, 5)));
// expected output: ""2006-01-02T15:04:05.000Z""

//const objVivienda[{"attribute_type_id":"5024","description":"Asientos","value":"20","start_date":null,"end_date":null,"duration":null}]
*/

// Crear o actualizar
const submit = () => {
    if (action.value == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('ref', 'label', 'description', 'price', 'cost_price', 'id_talla'),
        });
    } else {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onFinish: () => {
                form.reset('ref, label, description, price, cost_price, id_talla, tosell')
                clean('product')
            },
            onError: () => window.Toast.error(errors.create)
        });
    }

};



//const cancel = () => {
//if (rutaPrefijo.value=='student') {
//form.obs_aprendizaje = '';
//}
//}

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

//console.log(props.object)
const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}



/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

/**
 * Procesar archivos adjuntos
 */
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const listarDocumentos = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_document_product?src_object_id=' + props.object.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_document_product') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    if (type == 'file_document_product') {
        file = fileDocument.value.files[0];
        origin_id = props.object.id
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_document_product') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                listarDocumentos()
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
}

const backLink = ref(props.back_link ? '/#' + props.back_link : '')

</script>

<template>

    <Head :title="object ? object.label : 'Nuevo producto'" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader title="Nuevo producto" subtitle="Gestión de nuevo producto">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                <BaseButton :classLabel="'hidden sm:block'"
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
            </template>
        </PremiumPageHeader>
    </template>

        <div>


            <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

            <template v-if="(tab == 0)">
                <template v-if="action == 'view' && object">

                    <div class="grid grid-cols-1 gap-4 bg-white rounded-md border shadow-lg p-4 mb-4">
                        <div class="col-span-1">
                            <div class="grid grid-cols-1 md:flex flex-row gap-4 h-full">
                                <div class="col-span-1 h-auto my-auto">
                                    <img class="max-h-32 lg:max-h-36 rounded-lg border-2 border-gray-600 shadow-xl" :src="object.url ? '/img/dashboard/bg-popup.png' : '/img/dashboard/bg-popup.png'">
                                </div>
                                <div class="col-span-1 h-auto my-auto">
                                    <div class="flex items-center h-full justify-start">
                                        <div>
                                            <span class="text-2xl font-bold">{{
                                                object.label
                                            }}</span><br>
                                            <span class="font-bold mr-2">Descripción : </span>{{ object.description }}
                                            <br>

                                            <span class="font-bold mr-2">Precio sin impuesto : </span> {{ object.price }}<br>
                                            <span class="font-bold mr-2">Precio incluido IGV : </span> {{
                                                object.price_ttc
                                            }}, IGV Tasa : {{ object.tva_tx }}<br>
                                            <!-- <span class="font-bold mr-2">Talla : </span>{{ object.id_talla ? tallas.find(item => item.id === object.id_talla).label : '' }}
                                                <br> -->
                                            <span class="font-bold mr-2">Stock : </span>
                                            {{ object.stock }}<br>
                                            <span class="font-bold mr-2">En Venta : </span>{{ object.tosell ?
                                                'Si' :
                                                'No'
                                            }}<br>
                                            <!-- Referencia : {{ object.person.referencia }} -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- Modificar -->
                    <div v-if="canWrite" class="flex flex-row-reverse w-full">


                        <div class="col-span-1">
                            <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'" label=" Modificar" class="w-full" />
                        </div>

                        <!-- Aceso desde AdminCoord -->
                        <!-- <div class="grid md:cols-1 lg:grid-cols-8 gap-4">
                                        <div class="rounded-lg bg-white shadow-lg p-6 col-span-3 grid lg:col-start-6 gap-4">
                                            <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                                                <div class="col-span-1">
                                                    <BaseButton color="warning" :icon="mdiPencil" @click="action = 'edit'"
                                                        label=" Modificar" class="w-full" />
                                                </div>
                                                <div class="col-span-1">
                                                    <BaseButton v-if="object.status" color="danger"
                                                        @click="initModal('desactivar')" label="Deshabilitar (retirado)" class="w-full" />
                                                    <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                                        @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                        <!-- BOTONES -->
                        <!-- BOTONES -->

                        <!-- <-- cols-4 para cuatro botones o 3  -->
                        <!-- <div class="col-span-1">
                                                <BaseButton color="info" :icon="mdiPencil"
                                                    label=" Modificar" class="w-full" />
                                            </div>
                                            <div class="col-span-1">
                                                <BaseButton color="success" :icon="mdiPencil" 
                                                    label=" Modificar" class="w-full" />
                                            </div> -->

                        <!-- <div class="col-span-1">
                                        <BaseButton v-if="object.status" color="danger" @click="initModal('desactivar')"
                                            label="Deshabilitar (retirado)" class="w-full" />
                                        <BaseButton v-else color="success" :icon="mdiCheckCircle"
                                            @click="initModal('activar')" label=" Habilitar" class="w-full" />
                                    </div> -->

                    </div>

                </template>
                <!-- Editar -->
                <template v-else-if="action == 'edit' && canWrite">
                    <div class="grid grids-col-1 bg-white rounded-md border shadow-lg p-4">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Modificar</h3>
                        <form @submit.prevent="submit">
                            <FormField label="Etiqueta nombre / talla">
                                <!-- <FormControl v-model="form.ref" name="ref" type="text" required /> -->
                                <FormControl v-model="form.label" name="label" type="text" required />
                                <FormControl v-model="form.id_talla" type="select" :options="tallas" />
                            </FormField>
                            <FormField label="Descripción">
                                <FormControl v-model="form.description" type="textarea" />
                            </FormField>
                            <FormField label="Estado">
                                <FormControl v-model="form.tosell" type="yesno" placeholder="en venta" />
                                <FormControl v-model="form.tobuy" type="yesno" placeholder="en compra" />
                                <FormControl v-model="form.cost_price" type="number" placeholder="Precio de costo" title="Precio de costo" />
                            </FormField>
                            <FormField label="Precio">
                                <FormControl v-model="form.price" type="number" :set="(form.price = (form.price_ttc / (1 + (form.tva_tx / 100))))" labelinput="Precio Sin impuesto" readonly />
                                <FormControl v-model="form.tva_tx" type="select" :options="optionsIgvTasa" labelinput="Tasa IGV" />
                                <FormControl v-model="form.price_ttc" type="number" labelinput="Precio incluido IGV" />
                            </FormField>
                            <FormField label="Stock">
                                <!-- <FormControl v-model="form.stock" type="number" labelinput="Stock Inicial" /> -->
                                <FormControl v-model="form.stock_alerta" type="number" labelinput="Stock mínimo para alerta" />

                            </FormField>

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Already registered?
                                            </Link>-->
                                <!-- <BreezeButton @click="(action='view')" class="ml-4">
                                                Cancelar
                                            </BreezeButton> -->
                                <Link :href="route('product-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                </Link>

                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Actualizar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </template>
                <!-- Crear sólo desde el botón return dashboard-->
                <template v-else-if="action == 'create'">
                    <div class="grid grids-col-1 bg-white rounded-md border shadow-lg p-4">
                        <h3 class="md:text-2xl text-xl my-4 font-bold">Agregar nuevo producto</h3>
                        <form @submit.prevent="submit">
                            <FormField label="Etiqueta nombre / talla">
                                <!-- <FormControl v-model="form.ref" name="ref" type="text" required /> -->
                                <FormControl v-model="form.label" name="label" type="text" required />
                                <FormControl v-model="form.id_talla" type="select" :options="tallas" />
                            </FormField>
                            <FormField label="Descripción">
                                <FormControl v-model="form.description" type="textarea" />
                            </FormField>
                            <FormField label="Estado">
                                <FormControl v-model="form.tosell" type="yesno" placeholder="en venta" />
                                <FormControl v-model="form.tobuy" type="yesno" placeholder="en compra" />
                                <FormControl v-model="form.cost_price" type="number" placeholder="Precio de costo" title="Precio de costo" />
                            </FormField>
                            <FormField label="Precio">
                                <FormControl v-model="form.price" type="number" :set="(form.price = (form.price_ttc / (1 + (form.tva_tx / 100))))" labelinput="Precio Sin impuesto" readonly />
                                <FormControl v-model="form.tva_tx" type="select" :options="optionsIgvTasa" labelinput="Tasa IGV" />
                                <FormControl v-model="form.price_ttc" type="number" labelinput="Precio incluido IGV" />
                            </FormField>
                            <FormField label="Stock">
                                <FormControl v-model="form.stock" type="number" labelinput="Stock Inicial" />
                                <FormControl v-model="form.stock_alerta" type="number" labelinput="Stock mínimo para alerta" />
                            </FormField>

                            <div class="flex items-center justify-end mt-4">

                                <!-- <Link :href="route('student')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                                Volver al listado
                                            </Link> -->
                                <!-- <BaseButton
                                                color="contrast"
                                                :href="route('student')"
                                                small
                                                label=" Cancelar"
                                                class="ml-4"
                                            /> -->
                                <Link :href="route('product-list')">
                                    <BreezeButton class="ml-4" type="button">
                                        Cancelar
                                    </BreezeButton>
                                </Link>
                                <span v-if="!form.label" class="ml-3 font-medium text-red-600">Debe registrar una etiqueta o nombre</span>
                                <span v-else-if="!form.price_ttc && !form.price" class="ml-3 font-medium text-red-600">Debe asignar un precio</span>
                                <BreezeButton v-else class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Registrar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </template>

            </template>

            <!-- Documentos -->
            <template v-else-if="(tab == 3)">
                <div class="grid grid-cols-1 bg-white rounded-lg shadow-lg p-6 ">
                    <div class="col-span-1">
                        <h2 class="mb-3">Documentos adjuntos de {{ object.label }}</h2>
                        <!-- <div v-if="message">{{ message }}</div> -->
                        <div v-if="canWrite" class="">
                            <p class="my-2 text-sm mb-3">
                                Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                                PNG, con un <b>límite máximo</b> de {{
                                    confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                            </p>
                            <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                <small class="font-medium text-red-600">El archivo
                                    supera
                                    el tamaño límite permitido</small>
                            </div>
                            <div class="mb-4 w-full">
                                <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                                <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                            </div>
                            <div class="mb-4">
                                <label for="desc" class="text-sm mb-1">Descricpión (opcional) </label>
                                <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                            </div>
                            <!-- <div>
                                <BreezeLabel for="pos" value="Posición" />
                                <BreezeInput id="inputpos" type="number"
                                    class="mt-1 block" v-model="inputFilePos" />
                                </div> -->
                            <div class="mb-4">
                                <label>
                                    <input id="file_document_product" ref="fileDocument" type="file" @change="changeFile('file_document_product')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                </label>
                            </div>
                            <!-- <label>
                                    <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                                </label> -->

                            <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_document_product')" class="btn btn-blue px-8 lg:w-auto w-full" />
                        </div>
                        <hr class="my-4">
                        <!-- Lista -->
                        <div class="w-full overflow-x-auto relative">
                            <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_document_product" :originId="object.id" @reload="listarDocumentos()" />
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </div>
                    </div>
                </div>
            </template>


        </div>


    </BreezeAuthenticatedLayout>
</template>
